import { observer } from 'mobx-react'
import { FC } from 'react'

import { CaseRecordType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { FlexContainer, OptionsProps, Tooltip } from '@avantstay/backoffice-core'

import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { casesStore } from '@new/domains/operations/screens/CasesV2/stores/CasesStore'

interface AssignedFOPreviewFormatterProps {
  values?: string[]
}

const _AssignedFOPreviewFormatter: FC<AssignedFOPreviewFormatterProps> = ({ values }) => {
  const { caseInputs, isLoadingCaseInputs } = casesStore
  const { recordTypes } = casesFiltersStore
  if (isLoadingCaseInputs) return '...'

  const options = recordTypes?.reduce((acc: OptionsProps<string>[], recordType: CaseRecordType) => {
    const assignedFOList = caseInputs?.[recordType]?.assignedFO
    if (assignedFOList?.length) {
      assignedFOList.forEach(assignedFO => {
        acc.push({
          value: assignedFO.id,
          label: assignedFO.name,
          hasFullWidth: true,
        })
      })
    }
    return acc
  }, [] as OptionsProps<string>[]) as OptionsProps<string>[]

  if (!values?.length) return ''

  const listOfNames = values?.map(
    value => options?.find(option => option?.value === value)?.label as string,
  )

  const firstCreator = listOfNames?.[0]
  if (!firstCreator) return ''
  const parsedText = values.length > 1 ? `${firstCreator}, + ${values.length - 1}` : firstCreator
  return (
    <Tooltip
      content={
        <FlexContainer direction="column" alignItems="flex-start">
          {listOfNames.map(name => (
            <p key={name}>{name}</p>
          ))}
        </FlexContainer>
      }
      disabled={listOfNames.length === 0}
    >
      <div>{parsedText}</div>
    </Tooltip>
  )
}

export const AssignedFOPreviewFormatter = observer(_AssignedFOPreviewFormatter)
